import script from "./deviceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceDetail.vue?vue&type=script&setup=true&lang=js"

import "./deviceDetail.vue?vue&type=style&index=0&id=17f64542&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f64542"]])

export default __exports__